/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorImage = styled.img`
	width: 263px;
	margin: 0 0 ${"var(--ds-space-600, 48px)"} 0;
	display: flex;
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div`
	align-items: center;
	justify-content: center;
	display: flex;
	flex-wrap: wrap;
	margin: ${"var(--ds-space-1000, 80px)"} auto 0;
	max-width: 600px;
	flex-direction: column;

	@media (max-width: 640px) {
		flex-direction: column;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ImageOuter = styled.div`
	flex: none;
	flex-basis: 200px;
	justify-content: center;

	@media (max-width: 640px) {
		margin-right: 0;
		flex-basis: auto;

		& img {
			max-width: 100%;
			padding: 0 ${"var(--ds-space-300, 24px)"};
		}
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleWrapper = styled.div`
	display: flex;
	margin-bottom: ${"var(--ds-space-150, 12px)"};

	@media (max-width: 640px) {
		text-align: center;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	text-align: center;
	margin-top: ${"var(--ds-space-200, 16px)"};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.h1``;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.p`
	font-size: 1em;
	line-height: 24px;
	color: ${`var(--ds-text, ${N800})`};

	@media (max-width: 640px) {
		text-align: center;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorTextContainer = styled.div`
	display: flex;
	justify-content: center;
	text-align: center;
	flex-wrap: wrap;
	width: 80%;
	flex-direction: column;
	align-items: center;

	@media (max-width: 640px) {
		max-width: 304px;
		width: 100%;
	}
`;